import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import ApiContext from '@/context/ApiContext/ApiContext';
import HealthStatusContext from '@/context/HealthStatusContext/HealthStatusContext';
import { DeviceIdentifier } from '@/hooks/api/device-identifiers/types';

export default function useGetDeviceIdentifier() {
  const { client } = useContext(ApiContext);
  const { areSystemsAvailable } = useContext(HealthStatusContext);

  const dayInMs = 60 * 1000 * 60 * 24;

  const { data, isPending } = useQuery<
    DeviceIdentifier,
    AxiosError<{ message?: string }>
  >({
    queryKey: ['api', 'mhp-web', 'device-identifiers'],
    queryFn: async ({ queryKey }) => {
      return (await client.current!.get<DeviceIdentifier>(queryKey.join('/'))).data;
    },
    enabled: areSystemsAvailable,
    gcTime: dayInMs, // Renamed from cacheTime in React Query v5
    staleTime: dayInMs,
    retry: 1,
  });

  return {
    data, isPending,
  };
}
